import CheckedListItemRoot, { Props } from './CheckedListItem'

export default function CheckedListItem(props: Props) {
  return <CheckedListItemRoot {...props} />
}
